<template>
    <div class="homepage__tutorial">
        <div class="media">
            <h2 class="media__title">
                {{ $t('lp.tutorial.title') }}
            </h2>
            <h4 class="media__subtitle">
                {{ $t('lp.tutorial.subtitle') }}
            </h4>
            <div class="media__video video-player" @click="displayYtVideo">
                <div v-if="!showYtVideo" class="placeholder">
                    <div class="placeholder__play">
                        <div class="arrow arrow-right" />
                    </div>
                </div>
                <div v-else class="yt-wrapper">
                    <Youtube
                        ref="youtube"
                        data-hj-allow-iframe="true"
                        :resize="true"
                        :fit-parent="true"
                        :player-vars="playerVars"
                        :video-id="videoId"
                        :allowfullscreen="true"
                    />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Youtube from 'vue-youtube';
import { supportWebPImage } from '@/core/helpers/utils';
import { mapGetters } from 'vuex';

const defaultPlaceholderImageName = 'tutorial-video-placeholder.webp';
const spanishPlaceholderImageName = 'tutorial-video-placeholder--es.webp';
const defaultPlaceHolderFallbackImageName = 'tutorial-video-placeholder.png';
const spanishPlaceHolderFallbackImageName =
    'tutorial-video-placeholder--es.png';

export default {
    components: {
        Youtube,
    },
    data() {
        return {
            showYtVideo: false,
            videoId: null,
            spanishVideoId: 'h93eVUPT9Bs',
            defaultVideId: 'mlXCSQz8Fx0',
            playerVars: {
                autoplay: 1,
                origin: location.origin,
                disablekb: 1,
                showinfo: 0,
                modestbranding: 1,
                fs: 1,
            },
        };
    },
    computed: {
        ...mapGetters({ currentLanguage: 'getCurrentLanguage' }),
    },
    watch: {
        currentLanguage() {
            this.setPlaceHolderImageName();

            this.setVideoId();
        },
    },
    mounted() {
        this.setPlaceHolderImageName();

        this.setVideoId();
    },
    methods: {
        async displayYtVideo() {
            this.showYtVideo = true;

            this.$nextTick(async () => {
                const { player } = this.$refs.youtube;

                player.setVolume(50);

                player.playVideo();

                const iframe = await player.getIframe();

                const requestFullScreen =
                    iframe.requestFullScreen ||
                    iframe.mozRequestFullScreen ||
                    iframe.webkitRequestFullScreen;

                if (requestFullScreen && window.innerWidth < 1000) {
                    requestFullScreen.bind(iframe)();
                }
            });
        },
        setVideoId() {
            this.videoId =
                this.currentLanguage === 'es'
                    ? this.spanishVideoId
                    : this.defaultVideId;
        },
        setPlaceHolderImageName() {
            const elements = document.getElementsByClassName('placeholder');

            if (elements) {
                const element = elements[0];

                if (!element) {
                    return;
                }

                if (this.currentLanguage === 'es') {
                    if (!supportWebPImage()) {
                        element.style.backgroundImage = `url('/images/lp/${spanishPlaceHolderFallbackImageName}')`;
                    } else {
                        element.style.backgroundImage = `url('/images/lp/${spanishPlaceholderImageName}')`;
                    }
                } else {
                    if (!supportWebPImage()) {
                        element.style.backgroundImage = `url('/images/lp/${defaultPlaceHolderFallbackImageName}')`;
                    } else {
                        element.style.backgroundImage = `url('/images/lp/${defaultPlaceholderImageName}')`;
                    }
                }
            }
        },
    },
};
</script>

<style lang="scss" scoped>
.homepage__tutorial {
    .media {
        display: flex;
        flex-direction: column;
        align-items: center;
        padding: 0 1rem 140px;
        background-color: #ffc75a;

        @include mq($w-min-desktop, min) {
            padding: 0 5rem 180px;
        }

        &__title {
            color: #000;
            font-style: normal;
            font-weight: bold;
            font-size: 1.5rem;
            line-height: 1.8125rem;
            text-align: center;

            @include mq($w-min-desktop, min) {
                font-size: 3rem;
                line-height: 3.6875rem;
            }
        }

        &__subtitle {
            font-style: normal;
            font-weight: normal;
            color: #000000;
            margin: 0 0 1rem;

            @include mq($w-min-desktop, min) {
                font-size: 1.5rem;
                line-height: 1.8125rem;
                margin: 0 0 2rem;
            }
        }

        &__video {
            width: 100%;

            .placeholder {
                width: 100%;
                background: linear-gradient(
                        rgba(87, 37, 152, 0.5),
                        rgba(87, 37, 152, 0.5)
                    ),
                    url('/images/lp/tutorial-video-placeholder.webp');
                box-shadow: 0 4px 200px rgba(255, 255, 255, 0.2);
                background-size: cover;
            }
        }
    }
}
</style>
